import styled from "styled-components";

export const SideMenuToggleWrapper = styled.div`
`;